// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PfixOneTimePasswordMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_ONETIME_PASSWORD_MESSAGE, fieldSet);
    }
    GetPassword() {
        return this.getFieldValue(FieldsFactory.FIELD_PASSWORD);
    }
    GetId() {
        return this.getFieldValue(FieldsFactory.FIELD_ID);
    }
    EncryptionType() {
        const field = this.getFieldValue(FieldsFactory.FIELD_ID);
        return field !== null ? field : 0;
    }
}
